import(/* webpackMode: "eager", webpackExports: ["Base"] */ "/vercel/path0/app/_components/Base.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/global.css");
